import React, { FC, useMemo } from "react";
import { NavbarWidget } from "shared/components/__FOX__/NAV/src";
import styled, { useTheme } from "styled-components";
import { LayoutConst } from "core";
import { AppTester } from "supporting";
import { useSelector } from "react-redux";
import { HseContextSelector } from "shared/reducers/hseCurrentContext";
import { DropdownWithExternalsLinks } from "./components/contextTabsItems";
import { useBreakpoint } from "@brg/ui";
import AnchorNavigation from "../components/AnchorNavigation";
import { useGetFilteredTabs } from "../components/navigationSystem/useGetFilteredTabs";
import { DropdownWrapper } from "./HSEDeziiignNavbar";

export const LinksWrapper = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
`;

interface SectionDeziignProps {
    isFlexBoxEmpty?: boolean
}

const SectionDeziign: FC<SectionDeziignProps> = ({ isFlexBoxEmpty }) => {
    const theme = useTheme();
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isDvaDesign = AppTester.isDvaDesign();
    const isContiniumSite = AppTester.isContinuumSite();
    const is1600 = useBreakpoint(LayoutConst.screen.l_16);
    const is1650 = useBreakpoint(LayoutConst.screen.l_16 + 50);
    const is1200 = useBreakpoint(1200)
    const mac13 = useBreakpoint(LayoutConst.screen.mac13);
    const isKiiids = AppTester.isKiiidsArt();

    const { anchorsOverrideNavigation } = useSelector(HseContextSelector);

    const items = useGetFilteredTabs()

    //to-do сделать адаптивные элементы навбара
    const currentCutTabs = useMemo(() => {
        if (isKiiids && mac13) return 3
        else if (isKiiids && is1650) return 5;
        return 8
    } , [isKiiids, mac13, is1200, items])

    //to-do сделать адаптивные элементы навбара
    const cuttedItems = useMemo(() => {
        if (isKiiids && mac13) return items.slice(0, 4)
        if (isKiiids && is1650) return items.slice(0, 6)
        return (is1600 && isContiniumSite) ? items.slice(0, currentCutTabs) : items
    }, [is1600, isContiniumSite, mac13, isKiiids, items, is1650, currentCutTabs])

    const shouldDisplayDotsDropdown = useMemo( () => {
        if (isKiiids && is1650) return true
        return (is1600 && isContiniumSite)
    }, [is1600, isContiniumSite, is1650, isKiiids])

    const formatForExternalLinks = items.slice(currentCutTabs + 1).map(item => {
        return {
            active: item.active,
            ctx: "",
            external: item.external,
            isTeam: false,
            name: item.linkTo,
            title: item.content,
            value: item.linkTo,
            action: item.action,
            isModal: true,
            disabled: item.disabled,
        }
    })

    if (anchorsOverrideNavigation) {
        return <AnchorNavigation />
    }

    return (
        <LinksWrapper>
            <NavbarWidget.Links
                key="links-widget"
                theming={theme.navigationBar.links}
                items={cuttedItems}
            />
            {(isAgeytomesh || isDvaDesign || anchorsOverrideNavigation) && <AnchorNavigation />}
            {shouldDisplayDotsDropdown && !!formatForExternalLinks?.length && (
                <DropdownWrapper>
                    <DropdownWithExternalsLinks
                        maxHeight={460}
                        maxWidth={400}
                        isDarkTheme={isContiniumSite}
                        list={formatForExternalLinks}
                        initialTab={''}
                        isCustomTitle
                        hoverOpen
                    />
                </DropdownWrapper>
            )}
        </LinksWrapper>
    );
};

export default SectionDeziign;
import React, { FC, useMemo } from "react";
import { NavbarWidget } from "shared/components/__FOX__/NAV/src";
import styled, { useTheme } from "styled-components";
import { LayoutConst } from "core";
import { AppTester } from "supporting";
import { useSelector } from "react-redux";
import { HseContextSelector } from "shared/reducers/hseCurrentContext";
import { DropdownWithExternalsLinks } from "./components/contextTabsItems";
import { useBreakpoint } from "@brg/ui";
import AnchorNavigation from "../components/AnchorNavigation";
import { useGetFilteredTabs } from "../components/navigationSystem/useGetFilteredTabs";
import { DropdownWrapper } from "./HSEDeziiignNavbar";

export const LinksWrapper = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
`;

interface SectionDeziignProps {
    isFlexBoxEmpty?: boolean
}

const SectionDeziign: FC<SectionDeziignProps> = ({ isFlexBoxEmpty }) => {
    const theme = useTheme();
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isDvaDesign = AppTester.isDvaDesign();
    const isContiniumSite = AppTester.isContinuumSite();
    const is1600 = useBreakpoint(LayoutConst.screen.l_16);
    const is1650 = useBreakpoint(LayoutConst.screen.l_16 + 50);
    const is1200 = useBreakpoint(1200)
    const mac13 = useBreakpoint(LayoutConst.screen.mac13);
    const isKiiids = AppTester.isKiiidsArt();

    const { anchorsOverrideNavigation } = useSelector(HseContextSelector);

    const items = useGetFilteredTabs()

    //to-do сделать адаптивные элементы навбара
    const currentCutTabs = useMemo(() => {
        if (isKiiids && mac13) return 3
        else if (isKiiids && is1650) return 5;
        return 8
    } , [isKiiids, mac13, is1200, items])

    //to-do сделать адаптивные элементы навбара
    const cuttedItems = useMemo(() => {
        if (isKiiids && mac13) return items.slice(0, 4)
        if (isKiiids && is1650) return items.slice(0, 6)
        return (is1600 && isContiniumSite) ? items.slice(0, currentCutTabs) : items
    }, [is1600, isContiniumSite, mac13, isKiiids, items, is1650, currentCutTabs])

    const shouldDisplayDotsDropdown = useMemo( () => {
        if (isKiiids && is1650) return true
        return (is1600 && isContiniumSite)
    }, [is1600, isContiniumSite, is1650, isKiiids])

    const formatForExternalLinks = items.slice(currentCutTabs + 1).map(item => {
        return {
            active: item.active,
            ctx: "",
            external: item.external,
            isTeam: false,
            name: item.linkTo,
            title: item.content,
            value: item.linkTo,
            action: item.action,
            isModal: true,
            disabled: item.disabled,
        }
    })

    if (anchorsOverrideNavigation) {
        return <AnchorNavigation />
    }

    return (
        <LinksWrapper>
            <NavbarWidget.Links
                key="links-widget"
                theming={theme.navigationBar.links}
                items={cuttedItems}
            />
            {(isAgeytomesh || isDvaDesign || anchorsOverrideNavigation) && <AnchorNavigation />}
            {shouldDisplayDotsDropdown && !!formatForExternalLinks?.length && (
                <DropdownWrapper>
                    <DropdownWithExternalsLinks
                        maxHeight={460}
                        maxWidth={400}
                        isDarkTheme={isContiniumSite}
                        list={formatForExternalLinks}
                        initialTab={''}
                        isCustomTitle
                        hoverOpen
                    />
                </DropdownWrapper>
            )}
        </LinksWrapper>
    );
};

export default SectionDeziign;
